import React from 'react'
import styled from '@emotion/styled'

const CustomCheckbox = styled.input`
  position: relative;
  width: 1.5em;
  height: 1.5em;
  color: var(--color-gray-800);
  border: 1px solid var(--color-gray-500);
  border-radius: var(--space-4);
  appearance: none;
  outline: 0;
  cursor: pointer;
  transition: background-color 0.5s cubic-bezier(0.1, 0.1, 0.25, 1);
  &::before {
    position: absolute;
    content: '';
    display: block;
    bottom: var(--space-6);
    left: var(--space-8);
    width: var(--space-6);
    height: var(--space-12);
    border-style: solid;
    border-color: var(--color-white);
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    opacity: 0;
  }
  &:checked {
    color: var(--color-white);
    border-color: var(--company);
    background-color: var(--company);
    &::before {
      opacity: 1;
    }
 
  }

`;

export default CustomCheckbox;
